import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcTabs from '@shared/components/forms/inputs/tabs/tabs.vue';
import BpcBookingTable from '@bookings/components/tables/booking-table/booking-table.vue';
import BpcBookingEventTable from '@bookings/components/tables/booking-event-table/booking-event-table.vue';
import BpcContractTable from '@contracts/components/tables/contract-table/contract-table.vue';
import BpcDocumentTable from '@tools/components/tables/document-table/document-table.vue';
import BpcMessageTable from '@communications/components/tables/mailbox-table/mailbox-table.vue';
import { Contact } from '@contacts/interfaces/contact';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';

@Component({
  name: 'bpc-show-contact',
  components: {
    'bpc-tabs': BpcTabs,
    'bpc-booking-table': BpcBookingTable,
    'bpc-booking-event-table': BpcBookingEventTable,
    'bpc-contract-table': BpcContractTable,
    'bpc-document-table': BpcDocumentTable,
    'bpc-message-table': BpcMessageTable,
    'bpc-std-form': StdForm,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class ContactShow extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop({ type: Number, default: null }) readonly contact_id: number;
  @Prop({ type: [Contact, Object], default: () => ({}) }) readonly contact;
  public originShowContact: boolean = false;

  public entity: Contact = new Contact();
  public entityName = 'contact';
  public pluralEntityName = 'contacts';

  private selectedTab: string = null;
  i = 0;
  isSavingForm: boolean = false;

  get contactTabs() {
    const tabs = [
      { text: this.$t('contacts.contacts.tabs.contact_data'), value: 'contact_data' },
      { text: this.$t('contacts.contacts.tabs.bookings'), value: 'bookings' },
      // { text: this.$t('contacts.contacts.tabs.events'), value: 'events' },
      { text: this.$t('contacts.contacts.tabs.contracts'), value: 'contracts' },
      { text: this.$t('contacts.contacts.tabs.documents'), value: 'documents' },
    ];

    if (!this.originShowContact) {
      tabs.push({ text: this.$t('contacts.contacts.tabs.messages'), value: 'messages' });
    }

    return tabs;
  }

  get title() {
    return this.$t('contacts.contacts.show_page.title');
  }

  get subtitle() {
    return '';
  }

  get contactData() {
    return this.entity ? this.entity : this.contact;
  }

  get canManageContact() {
    return this.$authorizationService.hasPermissions([`manage_contacts`, `manage_own_contacts`]);
  }

  onChangeTab(event) {
    if (this.selectedTab !== this.contactTabs[event]['value']) {
      this.selectedTab = this.contactTabs[event]['value'];
      this.$router
        .push({
          query: { tab: this.selectedTab },
        })
        .catch(e => {
          return null;
        });
    }
  }

  onFormSaved($event: any = null) {
    this.isSavingForm = false;
  }

  onFormSave() {
    this.isSavingForm = true;
    this.$refs.stdForm.saveEntity();
  }

  onSavingEntity(event) {
    this.isSavingForm = event;
  }

  /* Lifecycle hooks */
  created() {
    this.originShowContact = this.$route.meta['originShowContact'];
  }

  mounted() {
    this.$root.$on('updateContact', event => {
      this.$refs.stdForm.formModel.to_invoice = event.to_invoice === 1;
      this.$refs.stdForm.formModel.when_to_invoice = event.when_to_invoice_value;
    });

    if ('tab' in this.$route.query) {
      this.selectedTab = this.$route.query.tab.toString();
    } else {
      this.selectedTab = 'contact_data';
    }

    if (this.selectedTab !== 'contact_data') {
      const path = `${this.$bpcApiRouteHelper.getEntityPath(this.entityName, 'raw')}/${
        this.contact_id
      }`;
      this.$bpcApi.get(path).subscribe(res => {
        this.entity = res.data;
      });
    }
  }
  // updated() {}
  // destroyed() {}
}
